import type { DateRange } from '@witmetrics/utils';
import { isValidDate } from '@witmetrics/utils/time';

export function getInitialValue(
  searchParams: URLSearchParams,
  defaultValue: DateRange
) {
  const startDate = searchParams.get('startDate');
  const endDate = searchParams.get('endDate');
  return hasValidValue(startDate) && hasValidValue(endDate)
    ? ([startDate, endDate] as DateRange)
    : defaultValue;
}

function hasValidValue(date?: string | null) {
  return date && isValidDate(date);
}
